import {Box, styled, TableContainer} from "@mui/material";

export const StyledDetailContainer = styled(Box)(
  ({theme}) => `
  margin-top: 32px;
`
);

export const DetailSubMenuGroup = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
`;

export const StyledDetailTable = styled(TableContainer)(({theme}) => ({
  marginTop: "16px",
  paddingLeft: "16px",
  paddingRight: "16px",
  paddingBottom: "32px",
  backgroundColor: theme.palette.background.paper,
  boxShadow: `rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem`,

  "& .subTitle": {
    fontSize: "18px",
    fontWeight: 600,
  },
  "& table th, td": {
    border: `1px solid ${theme.palette.warning.main}`,
    [theme.breakpoints.down("sm")]: {
      padding: "8px",
    },
  },

  "& tbody th": {
    padding: "8px",
    color: theme.palette.warning.dark,
    fontWeight: 700,
    backgroundColor: theme.palette.gray.light,
  },

  [theme.breakpoints.down("sm")]: {
    padding: 0,
  },
}));

export const StyledImageBox = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  marginTop: "16px",
  padding: "16px",
  backgroundColor: theme.palette.background.paper,
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));
